module.exports = __webpack_public_path__ + "media/mesg_auto1.d1209685.ogg";